import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { refineInvestedRequiresValue } from "web_myplann/Shared/Validation/refineInvestedRequiresValue";

export const refineManualValue = (t: TranslateFunction) =>
	refineInvestedRequiresValue(
		t(Resources.Portfolio.AddShared.Validations.valueRequiredWithInvested),
	);
